import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Shield } from '@sorare/core/src/atoms/icons/Shield';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM, LabelL, LabelM } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import { GridBackground } from '@sorare/gameplay/src/components/rivals/GridBackground';
import {
  BackgroundAligned,
  GridDiv,
} from '@sorare/gameplay/src/components/rivals/GridBackground/BackgroundAligned';

import { CreateSquadButton } from 'components/rivals/squads/CreateSquadButton';

const StyledBackgroundAligned = styled(BackgroundAligned)`
  width: 100%;
  padding: 0 var(--double-unit);
`;
const StyledGridDiv = styled(GridDiv)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    to right,
    var(--c-rivals-dark-purple),
    var(--c-rivals-purple)
  );
`;
const DropShadow = styled.div`
  filter: drop-shadow(0px 0px 50px var(--c-rivals-purple));
`;
const Wrapper = styled(Vertical).attrs({ gap: 2 })`
  padding: 0 var(--double-unit);
`;
const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--intermediate-unit);
`;

export const JoinSquad = () => {
  const creationLocked = false; //For testing until API is ready

  return (
    <Vertical gap={3}>
      <GridBackground height={240} color="#454545" intersectionOnCenter>
        <StyledBackgroundAligned>
          <Vertical center gap={2} className="text-center">
            <DropShadow>
              <StyledGridDiv>
                <Shield width={24} height={24} />
              </StyledGridDiv>
            </DropShadow>
            <Vertical gap={0}>
              <HeadlineM as="h2">
                <FormattedMessage
                  id="JoinSquad.title"
                  defaultMessage="Join or create a squad"
                />
              </HeadlineM>
              <LabelL>
                <FormattedMessage
                  id="JoinSquad.subtitle"
                  defaultMessage="Invite, play and compete with your friends"
                />
              </LabelL>
            </Vertical>
          </Vertical>
        </StyledBackgroundAligned>
      </GridBackground>
      <Wrapper className="text-center">
        <ButtonsWrapper>
          <Button color="secondary" size="large">
            <FormattedMessage {...glossary.join} />
          </Button>
          <CreateSquadButton creationLocked={creationLocked} />
        </ButtonsWrapper>
        {creationLocked && (
          <LabelM color="var(--c-neutral-700)">
            <FormattedMessage
              id="JoinSquad.creationLocked"
              defaultMessage="Get to {division} in Arena to unlock squad creation"
              values={{ division: 'Div 9' }} //todo get this value from backend once exposed
            />
          </LabelM>
        )}
      </Wrapper>
    </Vertical>
  );
};
